<template>
  <qx-card-form :title="title">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <!-- 载重容积 -->
      <section slot="goodsWeight" slot-scope="prop">
        <el-input
          class="appendInputBox"
          v-model="prop.form.goodsWeight"
          placeholder="载重"
          @change="calCostPrice"
        >
          <span slot="suffix">
            <span class="unit">吨</span>
            <el-input
              class="inputAppendInput"
              v-model="otherFormData.goodsVolume"
              :clear="true"
              placeholder="容积"
              @change="calCostPrice"
            >
              <span class="unit" slot="suffix">立方</span>
            </el-input>
          </span>
        </el-input>
      </section>
      <!-- 载重容积 end -->
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getCarTypeList,
} from 'api';
import {mapState} from 'vuex';
import {isNegativeNumber} from '@qx/utils';
export default {
  props: {
    goodsType: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      title: '车型及货物信息',
      otherFormData: {
        goodsVolume: '', // 容积
      },
      baseForm: {
        vehicleStatusOptions: [],
        goodsTypeOptions: [],
        inline: true,
        form: [
          {
            label: '车型要求',
            value: 'vehicleStatus',
            type: 'cascader',
            normal: true,
            width: '240px',
            default: [],
            hide: true,
          },
          {
            label: '载重容积',
            value: 'goodsWeight',
            slot: true,
          },
          {
            label: '货品名称',
            value: 'goodsName',
            type: 'input',
            width: '240px',
          },
          {
            label: '货品类型',
            value: 'goodsType',
            type: 'select',
            width: '240px',
          },
          {
            label: '计划数量',
            value: 'goodsNumber',
            type: 'input',
            unit: '件',
            // hide:true,
            onChange: () => {
              const goodsNumber = this.$refs.baseForm.getVal('goodsNumber');
              this.$refs.baseForm.setVal('goodsNumber', isNegativeNumber(goodsNumber));
              this.calCostPrice();
            },
          },
        ],
        rules: {
          vehicleStatus: [ // 车型要求
            { required: true, message: '请选择车型要求', trigger: 'blur' },
          ],
          goodsWeight: [ // 载重容积
            { required: true, message: '请输入载重', trigger: 'blur' },
            { validator: this.checkGoodsVolume, trigger: 'blur' },
          ],
          // goodsName: [ // 货品名称
          //   { required: true, message: '请输入货品名称', trigger: 'blur' },
          // ],
          goodsType: [ // 货品类型
            { required: true, message: '请选择货品类型', trigger: 'blur' },
          ],
          goodsNumber: [ // 计划数量
            { required: true, message: '请输入计划数量', trigger: 'blur' },
          ],
        },
      },
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息

    }),
  },
  methods: {
    calCostPrice () {
      this.$refs.baseForm.setVal('goodsWeight', isNegativeNumber(Number(this.$refs.baseForm.getVal('goodsWeight'))));
      this.otherFormData.goodsVolume = isNegativeNumber(Number(this.otherFormData.goodsVolume));
      this.$emit('calCostPrice');
    },

    checkGoodsVolume (rule, value, call) {
      if (this.otherFormData.goodsVolume !== '') {
        call();
      } else {
        call('请输入容积');
      }
    },
    async getList () {
      const vehicleStatusOptions = await getCarTypeList({
        unlimited: true,
      });
      this.baseForm.vehicleStatusOptions = vehicleStatusOptions;
      this.baseForm.goodsTypeOptions = this.goodsType;
    },
    async cacheData () {
      const formData = await this.$refs.baseForm.getVal();
      const arr = formData.vehicleStatus;
      formData.vehicleStatus = arr[0];
      formData.vehicleLength = arr[1];
      formData.goodsVolume = this.otherFormData.goodsVolume;
      return formData;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        const arr = formData.vehicleStatus;
        formData.vehicleStatus = arr[0];
        formData.vehicleLength = arr[1];
        formData.goodsVolume = this.otherFormData.goodsVolume;
      }
      return formData;
    },
    async init (data = {}) {
      // this.setFormAttrVal({
      //   form: this.baseForm,
      //   attr: 'hide',
      //   value: this.userInfo.customerType === '8',
      //   names: ['goodsNumber'],
      // });
      // if (this.userInfo.customerType === '8') {
      //   this.$refs.baseForm.setVal('goodsNumber', 0);
      // }
      if (data.goodsType) {
        data.goodsType = String(data.goodsType);
      }
      const res = {
        vehicleStatus: [data.vehicleStatus, data.vehicleLength],
        goodsWeight: data.goodsWeight,
        goodsName: data.goodsName,
        goodsType: data.goodsType || '1',
        goodsNumber: data.goodsNumber,
      };
      this.otherFormData.goodsVolume = data.goodsVolume;
      this.$refs.baseForm.setVal('form', res);
    },
  },
  created () {
    if (this.userInfo.staffTFInfo.tenantId === 2531 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538) {
      this.title = '货物信息';
    }
    this.setFormAttrVal({ // 姓名
      form: this.baseForm,
      attr: 'hide',
      value: this.userInfo.staffTFInfo.tenantId === 2531 || this.userInfo.staffTFInfo.tenantId === 2536 || this.userInfo.staffTFInfo.tenantId === 2538,
      names: ['vehicleStatus'],
    });
  },
};
</script>

<style scoped lang="scss">
.inputBox {
  margin-right: 12px;
}
.lineBox {
  margin-bottom: 16px;
}
</style>
